'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'light-switch';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e017';
var svgPathData = 'M0 0L384 0 384 512 0 512 0 0zM96 96l0 136 192 0 0-136-192 0zm0 184l0 136 192 0 0-136-192 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightSwitch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;